export const CHECKOUT_URL = 'https://refinamiento-it.impultienda.ar/checkout/'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/3p23qkrmczde3zokAENrh9/REFINAMIENTO-IT.png'

export const AUTHOR_IMAGE =
  'https://cdn.magicpatterns.com/uploads/qvggDrwiLPfxpdnRTuQnzS/Dra_Karito_real.png'

export const heroBadges = [
  'Download immediato',
  'Pagamento unico',
  'Accesso a vita',
  'Garanzia di 7 giorni',
]

export const pillars = [
  {
    title: 'Oltre 300 protocolli clinici',
    text: 'Tutto organizzato per trovare la risposta di cui hai bisogno in pochi minuti.',
    icon: 'library',
  },
  {
    title: '6 volumi specializzati',
    text: 'Dal primo esame diagnostico fino alla conclusione del trattamento.',
    icon: 'books',
  },
  {
    title: 'Compatibile con qualsiasi marca',
    text: 'Applica i protocolli indipendentemente dal sistema di allineatori che utilizzi.',
    icon: 'check',
  },
  {
    title: 'Consultazione rapida',
    text: 'Non dovrai leggere migliaia di pagine per trovare una soluzione.',
    icon: 'search',
  },
] as const

export const rootCauses = [
  'Nella diagnosi',
  'Nella pianificazione',
  'Nella biomeccanica',
  'Nell’approvazione del setup',
]

export const withoutSystem = [
  'Rifiniture continue',
  'Casi che sembrano non finire mai',
  'Setup approvati per intuizione',
  'Attachment posizionati automaticamente',
  'IPR eseguito in modo improvvisato',
  'Pazienti frustrati',
  'Bassa redditività',
]

export const withSystem = [
  'Meno rifiniture evitabili',
  'Trattamenti più prevedibili',
  'Pianificazioni basate su criteri clinici',
  'Attachment selezionati strategicamente',
  'Protocolli chiari per la riduzione interprossimale',
  'Pazienti con aspettative più realistiche',
  'Casi più efficienti',
]

export const painPoints = [
  {
    emoji: '😰',
    title:
      'Il paziente arriva al controllo e uno o più denti hanno smesso di seguire correttamente l’allineatore.',
    text: 'Sai già cosa succederà dopo. Un’altra rifinitura. Più tempo. Più appuntamenti. Più usura.',
  },
  {
    emoji: '⏰',
    title: 'Il trattamento va avanti da mesi e ancora non riesci a portarlo a termine.',
    text: 'Ogni nuovo appuntamento consuma tempo che potresti dedicare a nuovi pazienti.',
  },
  {
    emoji: '🤔',
    title: 'Approvi il setup perché visivamente sembra corretto…',
    text: '…ma qualcosa ti dice che quel movimento probabilmente non si esprimerà come appare sullo schermo.',
  },
  {
    emoji: '💰',
    title:
      'Quando fai i conti, scopri che il caso ha prodotto molto meno profitto di quanto previsto.',
    text: 'Le rifiniture riducono silenziosamente la redditività di ogni trattamento.',
  },
  {
    emoji: '😓',
    title: 'Il paziente inizia a chiederti perché il trattamento non è ancora terminato.',
    text: 'E ogni spiegazione rende più difficile mantenere la sua fiducia.',
  },
  {
    emoji: '📉',
    title: 'Sai che molte rifiniture potrebbero essere evitate…',
    text: 'Ma nessuno ti ha mai insegnato come individuare questi errori prima di iniziare.',
  },
]

export const howItWorks = [
  'Cerchi il problema',
  'Trovi il protocollo',
  'Lo applichi',
  'Prosegui il trattamento',
]

export const volumes = [
  {
    number: '01',
    title: 'Gli Errori che Generano le Rifiniture',
    text: 'Individua fin dalla prima visita i fattori che fanno perdere prevedibilità a un trattamento e riconosci i casi a maggior rischio prima ancora di iniziare.',
  },
  {
    number: '02',
    title: 'Pianificazione Clinica ad Alta Prevedibilità',
    text: 'Ottimizza qualsiasi setup prima di approvarlo utilizzando protocolli clinici che riducono gli errori e aumentano l’espressione reale dei movimenti pianificati.',
  },
  {
    number: '03',
    title: 'Il Controllo Totale del Movimento Dentale',
    text: 'Seleziona gli attachment più adatti, gestisci correttamente l’IPR e migliora la biomeccanica di ogni movimento per ottenere risultati più costanti.',
  },
  {
    number: '04',
    title: 'Monitoraggio Clinico Senza Deviazioni',
    text: 'Individua i problemi di tracking prima che si trasformino in rifiniture e applica protocolli di intervento durante le visite di controllo.',
  },
  {
    number: '05',
    title: 'Protocolli di Recupero Prima della Rifinitura',
    text: 'Recupera i trattamenti che iniziano a deviare utilizzando manovre cliniche, ausili e strategie che possono aiutarti a evitare nuovi set di allineatori.',
  },
  {
    number: '06',
    title: 'Chiusura Intelligente e Massima Redditività',
    text: 'Concludi i trattamenti utilizzando criteri chiari, evita rifiniture inutili all’ultimo momento e proteggi la redditività di ogni caso.',
  },
]

export const bonuses = [
  {
    label: 'BONUS #1',
    title: 'Calcolatore delle Perdite da Rifinitura™',
    value: '€37',
    text: 'Scopri quanto denaro sta realmente perdendo il tuo studio ogni volta che un trattamento richiede una rifinitura, considerando il tempo clinico, gli appuntamenti aggiuntivi e la riduzione della redditività.',
    image:
      'https://cdn.magicpatterns.com/uploads/8gomvbck4GNjdKVvgW2TiH/BONUS_1_REFINAMIENTO-IT.png',
  },
  {
    label: 'BONUS #2',
    title: 'Guida Express alle Correzioni Cliniche™',
    value: '€47',
    text: 'Quando un movimento smette di esprimersi correttamente, non sempre hai bisogno di nuovi allineatori. Applica protocolli di recupero, aggiustamenti clinici e manovre pratiche per riprendere il controllo del trattamento.',
    image:
      'https://cdn.magicpatterns.com/uploads/2nuBixEBGAmsr6eCKoBhJL/BONUS_2_REFINAMIENTO-IT.png',
  },
  {
    label: 'BONUS #3',
    title: 'Script Professionali per i Pazienti™',
    value: '€27',
    text: 'Riduci i reclami, migliora la comunicazione e stabilisci aspettative realistiche fin dalla prima visita. Include messaggi pronti da utilizzare in studio e su WhatsApp.',
    image:
      'https://cdn.magicpatterns.com/uploads/gB61TZt1P4uwAUZ7WueaxL/BONUS_3_REFINAMIENTO-IT.png',
  },
  {
    label: 'BONUS #4',
    title: 'Checklist Master per Approvare i ClinCheck™',
    value: '€37',
    text: 'Prima di fare clic su “Approva”, controlla questa lista dei punti critici. Uno strumento semplice che può aiutarti a individuare potenziali errori prima di iniziare il trattamento.',
    image:
      'https://cdn.magicpatterns.com/uploads/2zE4QhxxYKYz1b1NmzK1aZ/BONUS_4_REFINAMIENTO-IT.png',
  },
  {
    label: 'BONUS #5',
    title: 'Modelli di Consenso e Documenti™',
    value: '€37',
    text: 'Documenti pronti all’uso che aiutano a organizzare la documentazione del tuo studio, risparmiare tempo e lavorare con modelli professionali modificabili.',
    image:
      'https://cdn.magicpatterns.com/uploads/7QKPHHZX8yiY5YGRDeqMAE/BONUS_5_REFINAMIENTO-IT.png',
  },
]

export const offerRows = [
  { name: 'Sistema Anti-Rifiniture™', value: '€97' },
  { name: 'I 6 Volumi Clinici', value: 'Incluso' },
  { name: 'Oltre 300 Protocolli e Checklist', value: 'Incluso' },
  { name: 'Biblioteca dei Protocolli di Recupero', value: 'Incluso' },
  { name: 'Matrici di Prevedibilità', value: 'Incluso' },
  { name: 'Alberi Decisionali Clinici', value: 'Incluso' },
  { name: 'I 5 Bonus Esclusivi', value: '€185' },
]

export const testimonials = [
  {
    quote:
      'Ora controllo ogni pianificazione utilizzando la checklist prima di approvarla. Mi aiuta a individuare dettagli che prima passavano inosservati.',
    name: 'Dott.ssa María P.',
    country: 'Colombia 🇨🇴',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/4f836259-e0d6-4926-888d-7c857bf69ebe.jpg',
  },
  {
    quote:
      'Il volume dedicato alla pianificazione ha cambiato il mio modo di analizzare i setup. Oggi esamino ogni caso con molti più criteri clinici.',
    name: 'Dott. Roberto G.',
    country: 'Messico 🇲🇽',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/7ff904c5-4ec8-4387-96fe-ea34b2061591.jpg',
  },
  {
    quote:
      'I protocolli di recupero mi hanno dato alternative concrete per intervenire quando un movimento smette di seguire il piano iniziale.',
    name: 'Dott.ssa Andrea L.',
    country: 'Argentina 🇦🇷',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/002f9135-735e-4a85-a75b-993ab19c4602.jpg',
  },
  {
    quote:
      'Gli script per i pazienti mi hanno aiutato a spiegare meglio il trattamento e a ridurre molti dubbi durante i controlli.',
    name: 'Dott.ssa Carolina S.',
    country: 'Venezuela 🇻🇪',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/66e92eed-f5bf-42c7-b483-63d351722083.jpg',
  },
  {
    quote:
      'È uno strumento estremamente pratico. Non devo leggere centinaia di pagine: trovo il protocollo di cui ho bisogno e continuo a lavorare.',
    name: 'Dott. Jorge M.',
    country: 'Cile 🇨🇱',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/bd447e78-4968-41b4-a19b-5c38621f442f.jpg',
  },
]

export const faqs = [
  {
    q: 'Come ricevo il materiale?',
    a: 'Dopo aver completato l’acquisto, riceverai un’e-mail con accesso immediato per scaricare tutti i materiali.',
  },
  {
    q: 'Funziona con qualsiasi marca di allineatori?',
    a: 'Sì. Il sistema è stato progettato per concentrarsi su principi clinici, pianificazione, biomeccanica, controllo dei movimenti e protocolli applicabili indipendentemente dalla marca di allineatori utilizzata.',
  },
  {
    q: 'Devo installare un programma?',
    a: 'No. Il Sistema Anti-Rifiniture™ è un sistema digitale di consultazione. Non richiede l’installazione di software. Puoi accedere ai materiali dai tuoi dispositivi compatibili.',
  },
  {
    q: 'L’accesso ha una scadenza?',
    a: 'No. Con il pagamento unico di oggi ricevi accesso a vita.',
  },
  {
    q: 'È un pagamento mensile?',
    a: 'No. Paghi una sola volta. Nessun abbonamento. Nessun costo mensile. Nessun rinnovo automatico.',
  },
  {
    q: 'È utile anche per gli odontoiatri generici?',
    a: 'Il sistema è pensato per professionisti che lavorano con trattamenti ortodontici mediante allineatori e che desiderano avere una guida strutturata per analizzare, pianificare e controllare i propri casi.',
  },
]

export const finalBenefits = [
  'Più tempo disponibile per nuovi pazienti.',
  'Una migliore esperienza clinica.',
  'Maggiore controllo sul trattamento.',
  'Uno studio più efficiente e redditizio.',
]

export const purchaseNotifications = [
  { name: 'Dott.ssa Valentina R.', place: 'Bogotá, Colombia' },
  { name: 'Dott. Andrés M.', place: 'Città del Messico, Messico' },
  { name: 'Dott.ssa Lucía F.', place: 'Buenos Aires, Argentina' },
  { name: 'Dott. Sebastián T.', place: 'Santiago, Cile' },
  { name: 'Dott.ssa Camila O.', place: 'Lima, Perù' },
  { name: 'Dott. Javier N.', place: 'Madrid, Spagna' },
  { name: 'Dott.ssa Daniela C.', place: 'Quito, Ecuador' },
  { name: 'Dott. Rafael S.', place: 'Montevideo, Uruguay' },
  { name: 'Dott.ssa Paola G.', place: 'Caracas, Venezuela' },
  { name: 'Dott. Emilio V.', place: 'San José, Costa Rica' },
]
